
import { createSlice } from "@reduxjs/toolkit";
import { branchLogin, login } from "../async-actions/auth";


const initialState = {
  "full_name": "",
  "email": "",
  "username": "",
  "role_id": null,
  "profile_image": null,
  "id": null,
  "permissions": {},
  "token":null,
  "isLoggedin": false,
  'error': false
}


const accountSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    logOut: () => {
      return initialState
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        return state
      })
      .addCase(login.fulfilled, (state, action) => {
        state = { ...action.payload, isLoggedin: true }
        return state
      })
      .addCase(login.rejected, (state, action) => {
        state = { ...state, error: true }
        return state
      })
      .addCase(branchLogin.pending, (state) => {
        return state
      })
      .addCase(branchLogin.fulfilled, (state, action) => {
        state = { ...action.payload, isLoggedin: true }
        return state
      })
      .addCase(branchLogin.rejected, (state, action) => {
        state = { ...state, error: true }
        return state
      });
  },
});
export default accountSlice.reducer;
export const { logOut } = accountSlice.actions
